// Shared Web Push helpers (client + admin) and audio chime.
import api from "@/lib/api";
import { getLocalTxCodes } from "@/lib/localHistory";

export const CLIENT_PUSH_KEY = "sl_client_push";

export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function playChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    [880, 1174.66, 880].forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, now + i * 0.22);
      g.gain.exponentialRampToValueAtTime(0.35, now + i * 0.22 + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.22 + 0.55);
      o.connect(g);
      g.connect(ctx.destination);
      o.start(now + i * 0.22);
      o.stop(now + i * 0.22 + 0.6);
    });
    setTimeout(() => ctx.close().catch(() => null), 2000);
  } catch (_e) { /* ignore */ }
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

async function getSubscription() {
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/vapid-public-key");
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  return sub;
}

// Client device: subscribe to status updates for locally tracked tx codes.
export async function subscribeClientPush() {
  const sub = await getSubscription();
  await api.post("/push/subscribe-client", {
    subscription: sub.toJSON(),
    tx_codes: getLocalTxCodes(),
    device_label: navigator.userAgent.slice(0, 120),
  });
  localStorage.setItem(CLIENT_PUSH_KEY, "1");
  return sub;
}

// Re-sync silently if the user already opted in (new tx codes, SW re-registered after deploy).
export async function syncClientPush() {
  if (!pushSupported()) return;
  if (localStorage.getItem(CLIENT_PUSH_KEY) !== "1") return;
  if (Notification.permission !== "granted") return;
  try {
    await subscribeClientPush();
  } catch (_e) { /* ignore */ }
}

// Admin device subscription.
export async function subscribeAdminPush() {
  const sub = await getSubscription();
  await api.post("/push/subscribe", {
    subscription: sub.toJSON(),
    device_label: navigator.userAgent.slice(0, 120),
  });
  return sub;
}
